import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';
import { decode } from 'html-entities';

import { greenCheck } from 'assets';

import { SmartEventConditionsTable } from '../Conditions';
import { SmartEventActionsTable } from '../Actions';

interface IReviewStepProps {
  conditions?: ISmartEventConditionForm[];
  actions?: ISmartEventActionForm[];
  description?: string;
  hideReview?: boolean;
  managedSmartEvent?: IGetSmartEvent;
}

const ReviewStep = ({
  hideReview = false,
  description,
  conditions,
  actions,
  managedSmartEvent
}: IReviewStepProps) => {
  const intl = useIntl();
  const [parsedConditions, setParsedConditions] = useState<string[]>([]);
  const [parsedActions, setParsedActions] = useState<string[]>([]);
  const [parsedDetails, setParsedDetails] = useState<string[]>([]);

  useEffect(() => {
    if (managedSmartEvent) {
      setParsedConditions(JSON.parse(managedSmartEvent.conditions));
      setParsedActions(JSON.parse(managedSmartEvent.actions));
      setParsedDetails(JSON.parse(managedSmartEvent.details));
    }
  }, [managedSmartEvent]);

  return (
    <>
      {!hideReview && (
        <>
          <h4 className="mb-4">{intl.formatMessage({ id: 'confirmationKey' })}</h4>
          <div className="d-flex align-items-center p-4 bg-blue-light mb-4 br-5">
            <img src={greenCheck} />
            <p className="m-0 ms-3">{intl.formatMessage({ id: 'confirmInformationKey' })}</p>
          </div>
        </>
      )}

      {managedSmartEvent ? (
        <>
          <h6>{intl.formatMessage({ id: 'descriptionKey' })}</h6>
          <p data-test="smart-event-view-modal-title" className="bg-light p-2">
            {intl.formatMessage({ id: managedSmartEvent.attribute })}
          </p>
          <h6>{intl.formatMessage({ id: 'conditionsKey' })}</h6>
          <ul>
            {parsedConditions.length > 0 ? (
              parsedConditions.map((condition: string, index) => {
                return (
                  <li
                    data-test={`smart-event-view-modal-condition-${index}`}
                    className="p-1"
                    key={condition}
                  >
                    {intl.formatMessage({ id: condition })}
                  </li>
                );
              })
            ) : (
              <p data-test="smart-event-view-modal-conditions-empty">
                {intl.formatMessage({ id: 'noConditionsKey' })}
              </p>
            )}
          </ul>
          <h6>{intl.formatMessage({ id: 'actionsKey' })}</h6>
          <ul>
            {parsedActions.length > 0 ? (
              parsedActions.map((action: string, index) => {
                return (
                  <li
                    data-test={`smart-event-view-modal-action-${index}`}
                    className="p-1"
                    key={action}
                  >
                    {intl.formatMessage({ id: action })}
                  </li>
                );
              })
            ) : (
              <p data-test="smart-event-view-modal-actions-empty">
                {intl.formatMessage({ id: 'noActionsKey' })}
              </p>
            )}
          </ul>
          <h6>{intl.formatMessage({ id: 'detailsKey' })}</h6>
          <ul>
            {parsedDetails.length > 0 ? (
              parsedDetails.map((detail: string, index) => {
                return (
                  <li
                    data-test={`smart-event-view-modal-detail-${index}`}
                    className="p-1"
                    key={detail}
                  >
                    {intl.formatMessage({ id: detail })}
                  </li>
                );
              })
            ) : (
              <p data-test="smart-event-view-modal-details-empty">
                {intl.formatMessage({ id: 'noDetailsKey' })}
              </p>
            )}
          </ul>
        </>
      ) : (
        <>
          <h6>{intl.formatMessage({ id: 'descriptionKey' })}</h6>
          <p data-test="smart-event-view-modal-title" className="mb-4 p-2 bg-light">
            {decode(description)}
          </p>
          <h6>{intl.formatMessage({ id: 'conditionsKey' })}</h6>
          <SmartEventConditionsTable conditions={conditions || []} />
          <h6>{intl.formatMessage({ id: 'actionsKey' })}</h6>
          <SmartEventActionsTable actions={actions || []} />
        </>
      )}
    </>
  );
};

export default ReviewStep;
